<template>
  <div class="login-wrapper">
    <div class="login-inner">
      <md-field>
        <md-tabs v-model="activeName">
          <md-tab-pane name="mobile" :label="$t('mobile')">
            <div v-if="activeName === 'mobile'">
              <div class="form-label">{{$t('mobile')}}</div>
              <md-input-item
                type="digit"
                v-model="form.mobile"
                class="bordered mobile-input"
                ref="mobileNumber"
                name="mobileNumber"
                placeholder=""
                v-validate="'required|betweenLength:8,13'"
                :error="errors.first('mobileNumber')"
              >
                <div slot="left" class="mobile-prefix" @click="showSelector">
                  <span class="prefix-text">{{form.mobileCountry}}</span>
                  <md-icon name="arrow-down" size="sm"></md-icon>
                </div>
              </md-input-item>
            </div>
          </md-tab-pane>
          <md-tab-pane name="email" :label="$t('email')">
            <div v-if="activeName === 'email'">
              <div class="form-label">{{$t('email')}}</div>
              <md-input-item
                type="text"
                class="bordered"
                name="email"
                ref="email"
                v-model="form.email"
                v-validate="'required|email'"
                :error="errors.first('email')"
              >
              </md-input-item>
            </div>
          </md-tab-pane>
        </md-tabs>
        <div class="form-label">{{$t('password')}}</div>
        <md-input-item
          type="password"
          class="bordered"
          v-model="form.password"
          ref="password"
          name="password"
          v-validate="'required|betweenLength:8,16'"
          :error="errors.first('password')"
        >
        </md-input-item>
      </md-field>
      <md-selector
        class="mobile-prefix-selector"
        v-model="selectorVisible"
        :data="mobilePrefixList"
        default-value="+62"
        cancel-text="cancel"
        title="Mobile Prefix"
        max-height="400px"
        @choose="onSelectorChoose($event)"
      ></md-selector>
      <button-primary type="primary" class="btn-submit" @click="submit" :loading="loading">
        {{ $t('login') }}
      </button-primary>
      <div class="btn-bottom">
        <md-button type="link" @click="switchRoute('ForgetPassword')">{{ $t('forgotPassword') }}</md-button>
        <!--<md-button type="link" @click="switchRoute('Signup')">{{ $t('register') }}</md-button>-->
      </div>
    </div>
  </div>
</template>

<script>
import { Field, FieldItem, Icon, InputItem, Selector, Button, Tabs, TabPane } from 'mand-mobile'
import ForgetPassword from '@/components/common/ForgetPassword'
import Cookie from 'js-cookie'

export default {
  i18n: {
    messages: {
      en: {
        borrower: 'Borrower',
        borrowerText: 'Download our app to borrow up to 2 Million Rupiah!',
        download: 'Download Kredit Pintar',
        email: 'Email',
        forgotPassword: 'Reset Password',
        invalid: 'Please input the correct username and password',
        investor: 'Lender',
        login: 'Login',
        mobile: 'Mobile',
        password: 'Password',
        register: 'Sign Up',
      },
      id: {
        borrower: 'Peminjam',
        borrowerText: 'Klik di bawah ini untuk mengajukan pinjaman sebesar 2 juta Rupiah',
        download: 'Unduh Kredit Pintar',
        email: 'Email',
        forgotPassword: 'Lupa Password',
        invalid: 'Silahkan memasukkan username dan kata sandi yang benar',
        investor: 'Pemberi Pinjaman',
        login: 'Masuk',
        mobile: 'No. Ponsel',
        password: 'Kata Sandi',
        register: 'Daftar',
      },
    },
  },
  components: {
    ForgetPassword,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  data() {
    return {
      titles: [this.$t('mobile'), this.$t('email')],
      defaultIndex: 0,
      activeName: 'mobile',
      form: {
        email: '',
        mobileCountry: '+62',
        mobile: '',
        password: '',
      },
      mobilePrefixList: [
        { text: '+61', value: '+61' },
        { text: '+62', value: '+62' },
        { text: '+65', value: '+65' },
        { text: '+81', value: '+81' },
        { text: '+82', value: '+82' },
        { text: '+852', value: '+852' },
        { text: '+86', value: '+86' },
        { text: '+886', value: '+886' },
      ],
      displayForgetPassword: false,
      selectorVisible: false,
      fromRouteName: '',
      loading: false,
    }
  },
  computed: {},
  methods: {
    showSelector() {
      this.selectorVisible = true
    },
    onSelectorChoose({ text }) {
      this.form.mobileCountry = text
    },
    async submit() {
      const valid = await this.$validator.validate()
      if (!valid) return
      try {
        const payload = {
          username: {
            email: this.form.email,
            mobile: `${this.form.mobileCountry}${this.form.mobile}`,
          }[this.activeName.toLowerCase()].trim(),
          password: this.form.password,
        }
        this.loading = true
        const response = await this.$http.post('/auth/login', payload)
        if (response.data.code === 'SUCCESS') {
          Cookie.set('x-request-token', response.data.data.accessToken)
          await Promise.all([
            this.$store.dispatch('reloadInvestor', { force: true }),
            this.$store.dispatch('reloadAccount', { force: true }),
          ])
          if (this.fromRouteName) {
            this.switchRoute(this.fromRouteName)
          } else {
            this.switchRoute('Home')
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    switchRoute(name) {
      this.$router.push({ name: name })
    },
    download() {
      window.open('https://go.onelink.me/o4cz?pid=p2p', '_blank')
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name) {
        vm.fromRouteName = from.name
      }
    })
  },
}
</script>

<style lang="stylus" scoped>
.login-wrapper {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
  padding: 32px 16px;
  min-height: calc(100vh - 64px);
}

.login-inner {
  padding: 0 16px 8px;

}

.form-label {
  font-size: 14px;
  margin: 15px 0 8px 0;
}

.btn-submit {
  width: 100%;
  margin: 20px 0 15px;
}

.login-wrapper /deep/ {
  .md-input-item {
    padding: 0;
  }
  .md-button.link.large {
    font-size: 14px;
    font-weight: 500;
    color: color-primary;
    width: unset;
  }
  .md-tab-content {
    padding-bottom: 10px;
  }
}

.btn-bottom {
  display: flex;
  justify-content: space-between;
}
</style>
